import { SortingParam } from 'src/common/components/Filters/constants/sorting';

type ProductSummaryQueriesListProps = {
  page: number;
  pageSize: number;
  accountRef: string | null;
  sorting: SortingParam;
};

export const productSummaryQueries = {
  all: ['ProductSummary'],
  listAll: () => [...productSummaryQueries.all, 'List'],
  list: (filters: ProductSummaryQueriesListProps) => [...productSummaryQueries.listAll(), filters],
  lastUpdateTimestamp: () => [...productSummaryQueries.all, 'Last update timestamp'],
};
